import { InfiniteData } from '@tanstack/react-query';
import { CommentGetAllResponse } from '@/shared/api';
import { ChatMessage, ChatMessageType } from '../model/types';

type AiConversationHistoryResponse = Array<{
  id: string;
  content: string;
  createdAt: string;
  role: ChatMessageType;
}>;

export const aiConversationHistoryResponseToMessages = (
  response: AiConversationHistoryResponse | undefined,
): Array<ChatMessage> | undefined => {
  return response?.map((item) => ({
    id: item.id,
    text: item.content,
    created: {
      at: item.createdAt,
      by: { type: item.role },
    },
  }));
};

export const agentConversationHistoryResponseToMessages = (
  response: InfiniteData<CommentGetAllResponse> | undefined,
): Array<ChatMessage> | undefined => {
  return response?.pages
    .map(({ data }) => {
      return data.map((item) => ({
        id: item.id,
        text: item.comment,
        assets: item.assets,
        created: item.created as ChatMessage['created'],
      }));
    })
    .flat()
    .reverse();
};
